module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-analytic-1.89dcd7a4.svg";